<template>
    <main class="home-view">
        <section class="cover hero-cover">
            <div class="cover-bg"></div>
            <video class="hero-video" autoplay loop :muted="isMobileDevice()" playsinline :poster="assets.transparent" preload="metadata">
                <source media="(min-width: 768px)" :src="$t('pages.home.hero-cover.video.webm.md')" type="video/webm" />
                <source media="(min-width: 768px)" :src="$t('pages.home.hero-cover.video.mp4.md')" type="video/mp4" />
                <source :src="$t('pages.home.hero-cover.video.webm.xs')" type="video/webm">
                <source :src="$t('pages.home.hero-cover.video.mp4.xs')" type="video/mp4">
            </video>
            <img class="scroll-down-indicator" src="~@/assets/images/covers/hero-video-scroll-down.svg">
        </section>
        <section class="cover ruyi-cover">
            <div class="cover-bg" :style="styles.ruyi.coverBg" v-parallax="0.3"></div>
            <div class="cover-content" v-parallax="0.15">
                <h1 class="cover-title">{{ $t('pages.ruyi.title') }}</h1>
                <h2 class="cover-subtitle">{{ $t('pages.ruyi.subtitle') }}</h2>
                <br>
                <router-link class="action-button cover-action-button" :to="{ name: `${$i18n.locale}.ruyi` }">
                    <img src="~@/assets/images/plus-circle-o.svg">
                </router-link>
            </div>
        </section>
        <section class="cover technology-cover">
            <div class="cover-bg" :style="styles.technology.coverBg" v-parallax="0.3"></div>
            <div class="cover-content" v-parallax="0.15">
                <h1 class="cover-title">{{ $t('pages.technology.title') }}</h1>
                <h2 class="cover-subtitle">{{ $t('pages.technology.subtitle') }}</h2>
                <br>
                <router-link class="action-button cover-action-button" :to="{ name: `${$i18n.locale}.technology` }">
                    <img src="~@/assets/images/plus-circle-o.svg">
                </router-link>
            </div>
        </section>
        <section class="cover fashion-cover">
            <div class="cover-bg" :style="styles.fashion.coverBg" v-parallax="0.3"></div>
            <div class="cover-content" v-parallax="0.15">
                <h1 class="cover-title">{{ $t('pages.fashion.title') }}</h1>
                <h2 class="cover-subtitle">{{ $t('pages.fashion.subtitle') }}</h2>
                <br>
                <router-link class="action-button cover-action-button" :to="{ name: `${$i18n.locale}.fashion` }">
                    <img src="~@/assets/images/plus-circle-o.svg">
                </router-link>
            </div>
        </section>
        <section class="cover sustainability-cover">
            <div class="cover-bg" :style="styles.sustainability.coverBg" v-parallax="0.3"></div>
            <div class="cover-content" v-parallax="0.15">
                <h1 class="cover-title">{{ $t('pages.sustainability.title') }}</h1>
                <h2 class="cover-subtitle">{{ $t('pages.sustainability.subtitle') }}</h2>
                <br>
                <router-link class="action-button cover-action-button" :to="{ name: `${$i18n.locale}.sustainability` }">
                    <img src="~@/assets/images/plus-circle-o.svg">
                </router-link>
            </div>
        </section>
    </main>
</template>

<script>
  import { isMobileDevice } from '@/helpers/utils'
  import getMatchedBreakpoint from '../mixins/getMatchedBreakpoint'
  import updateHead from '../mixins/updateHead'

  export default {
    computed: {
      assets () {
        return {
          transparent: require('@/assets/images/transparent.png'),
          cover: {
            ruyi: {
              xs: this.$t('pages.ruyi.cover.xs'),
              md: this.$t('pages.ruyi.cover.md'),
              xl: this.$t('pages.ruyi.cover.xl')
            },
            technology: {
              xs: this.$t('pages.technology.cover.xs'),
              md: this.$t('pages.technology.cover.md'),
              xl: this.$t('pages.technology.cover.xl')
            },
            fashion: {
              xs: this.$t('pages.fashion.cover.xs'),
              md: this.$t('pages.fashion.cover.md'),
              xl: this.$t('pages.fashion.cover.xl')
            },
            sustainability: {
              xs: this.$t('pages.sustainability.cover.xs'),
              md: this.$t('pages.sustainability.cover.md'),
              xl: this.$t('pages.sustainability.cover.xl')
            }
          }
        }
      },
      styles () {
        return {
          ruyi: {
            coverBg: {
              backgroundImage: `url(${this.assets.cover.ruyi[this.matchedBreakpoint]})`
            }
          },
          technology: {
            coverBg: {
              backgroundImage: `url(${this.assets.cover.technology[this.matchedBreakpoint]})`
            }
          },
          fashion: {
            coverBg: {
              backgroundImage: `url(${this.assets.cover.fashion[this.matchedBreakpoint]})`
            }
          },
          sustainability: {
            coverBg: {
              backgroundImage: `url(${this.assets.cover.sustainability[this.matchedBreakpoint]})`
            }
          }
        }
      }
    },
    methods: {
      isMobileDevice
    },
    head: {
      title () {
        return {
          inner: this.$t('pages.home.title'),
          complement: this.$t('common.ruyi-group')
        }
      }
    },
    mixins: [
      getMatchedBreakpoint,
      updateHead
    ]
  }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    @keyframes heroVideoScrollDown {
        0% {
            transform: translateY(-100%);
        }
        5% {
            transform: translateY(0);
        }
        10% {
            transform: translateY(-100%);
        }
        100% {
            transform: translateY(-100%);
        }
    }

    .home-view {
        .hero-cover {
            height: 100vh;
            position: relative;

            .hero-video {
                height: auto;
                left: 50%;
                max-width: none;
                min-width: 100%;
                min-height: 100%;
                position: absolute;
                top: 50%;
                transform: translate(-50%,-50%);
                width: auto;
            }

            .scroll-down-indicator {
                animation: heroVideoScrollDown 5s infinite;
                bottom: 0%;
                left: calc(50% - 30px);
                position: absolute;
            }

            .cover-action-button {
                position: relative;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// Home.vue?12932a3f